import * as React from 'react';
import { Link } from 'react-router-dom';

interface ItemProps {
  active?: boolean;
  to?: string;
  children?: React.ReactNode[] | React.ReactNode;
}

const Item = ({ active, to, children }: ItemProps) => {
  if (active === false) {
    return <span className="breadcrumb-item active">{children}</span>;
  }

  return (
    <span className="breadcrumb-item">
      <Link to={to || ''}>{children}</Link>
    </span>
  );
};

export default Item;
